<mat-table
  [dataSource]="tableItems"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  multiTemplateDataRows
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
    <mat-cell *matCellDef="let item"
      >{{ item?.name[0]?.firstName }} {{ item?.name[0]?.lastName }}</mat-cell
    >
  </ng-container>

  <ng-container matColumnDef="dob">
    <mat-header-cell *matHeaderCellDef> Age </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item?.dob }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="phone">
    <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item?.phone[0]?.phoneNumber }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="email">
    <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item?.email[0] }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
    <mat-cell *matCellDef="let item"
      >{{ item?.startDate ? item.startDate : '' }}{{ item?.startDate && item?.endDate ? ' - ' : ''
      }}{{ item?.endDate ? item.endDate : '' }}</mat-cell
    >
  </ng-container>

  <ng-container matColumnDef="pdf">
    <mat-header-cell *matHeaderCellDef> PDF </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-icon-button
        icon="download"
        class="whooster-icon"
        matTooltip="Download"
        matTooltipPosition="below"
        (click)="whoosterPdf(item)"
      ></sn-icon-button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="detailView">
    <mat-cell
      *matCellDef="let element"
      [attr.colspan]="columns.length"
      [class.detailExpanded]="isExpanded(element.uuid)"
    >
      <div class="detail" [@snDetailExpand]="isExpanded(element.uuid) ? 'expanded' : 'collapsed'">
        <sn-whooster-address-details [data]="element"></sn-whooster-address-details>
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="toggleExpanded(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['detailView']" class="detail-row"></mat-row>
</mat-table>

<button *ngIf="!lessToggle() && hasThree()" color="accent" mat-button (click)="allItems()">
  show more
</button>
<button *ngIf="lessToggle() && hasThree()" color="accent" mat-button (click)="threeItems()">
  show less
</button>
